import * as t from '../types'
import * as helpers from './helperFunctions'

export default function calcPrices(
  priceProps: t.ProductPriceDefinition
): t.TotalPrices {
  const { mapPricesToObject, reduction } = helpers
  let prices = mapPricesToObject(priceProps)
  // customTailorNetPriceTotalCurrency
  // customTailorGrossPriceTotalCurrency
  // cheapestNetPriceSingleCurrency
  // cheapestGrossPriceSingleCurrency
  // reducedNetPriceSingleCurrency
  // reducedGrossPriceSingleCurrency
  // reducedPseudoNetPriceSingleCurrency
  // reducedPseudoGrossPriceSingleCurrency
  // pseudoNetPriceTotalCurrency
  // pseudoGrossPriceTotalCurrency
  // ecoTaxNetTotalCurrency
  // ecoTaxGrossTotalCurrency
  prices.net.piece.Price &&
    prices.net.piece.PseudoPrice &&
    (prices = {
      ...prices,
      reducedPrice: reduction(
        prices.net.piece.Price,
        prices.net.piece.PseudoPrice
      )
    })

  return prices
}
